// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-9DDA256B-BBD0-4444-9CE3-87AC6AB03C06 .zero-padding > div {\n  padding: 0px !important;\n}\n", "",{"version":3,"sources":["webpack://src/Warehouse/periodicWarehouseCheckUp/periodicWarehouseCheckUp.less"],"names":[],"mappings":"AAAA;EAEQ,uBAAA;AAAR","sourcesContent":["#V-9DDA256B-BBD0-4444-9CE3-87AC6AB03C06{\n    .zero-padding > div{\n        padding: 0px !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
